import { render } from "./VerifiedEmail.vue?vue&type=template&id=5638b412"
import script from "./VerifiedEmail.vue?vue&type=script&lang=js"
export * from "./VerifiedEmail.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/touran-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__